export const ON_INACTIVE_CLIENT = "ON_INACTIVE_CLIENT";
export const ON_INACTIVE_CLIENT_SUCCESS = "ON_INACTIVE_CLIENT_SUCCESS";
export const ON_INACTIVE_CLIENT_FAIL = "ON_INACTIVE_CLIENT_FAIL";

export const GET_CLIENT_SETTING = "GET_CLIENT_SETTING";
export const GET_CLIENT_SETTING_SUCCESS = "GET_CLIENT_SETTING_SUCCESS";
export const GET_CLIENT_SETTING_FAIL = "GET_CLIENT_SETTING_FAIL";